var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShortText = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5714 3C14.8081 3 15 3.19188 15 3.42857V5.57143C15 5.80812 14.8081 6 14.5714 6H14.1429C13.9062 6 13.7143 5.80812 13.7143 5.57143V4.71429H9.85714V13.7143H11.1429C11.3795 13.7143 11.5714 13.9062 11.5714 14.1429V14.5714C11.5714 14.8081 11.3795 15 11.1429 15H6.85714C6.62045 15 6.42857 14.8081 6.42857 14.5714V14.1429C6.42857 13.9062 6.62045 13.7143 6.85714 13.7143H8.14286V4.71429H4.28571V5.57143C4.28571 5.80812 4.09384 6 3.85714 6H3.42857C3.19188 6 3 5.80812 3 5.57143V3.42857C3 3.19188 3.19188 3 3.42857 3H14.5714Z",
  fill: "currentColor"
})));
export default SvgShortText;